import { motion } from "framer-motion";

const STATS = [
  { num: "₹9 → ₹40,000", label: "the upsell ladder, one webinar", tone: "text-warn" },
  { num: "3 of 3", label: 'bundles bought — all resold "resell-rights" files', tone: "text-ink" },
  { num: "2", label: "proofs required per verified review", tone: "text-verified" },
];

export const StatBand = () => (
  <section data-testid="stat-band" className="bg-white border-y border-black/5">
    <div className="max-w-6xl mx-auto px-6 py-14 grid sm:grid-cols-3 gap-10 sm:gap-0 sm:divide-x sm:divide-gray-100">
      {STATS.map((s, i) => (
        <motion.div
          key={s.num}
          data-testid={`stat-${i}`}
          className="sm:px-10 first:pl-0"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.55, delay: i * 0.12 }}
        >
          <div className={`font-display text-3xl sm:text-4xl font-bold tracking-tight ${s.tone}`}>{s.num}</div>
          <div className="mt-2 text-sm text-gray-500">{s.label}</div>
        </motion.div>
      ))}
    </div>
  </section>
);
